import { Reducer } from 'react'
import { handleActions } from 'redux-actions'
import {
    ACTION_GETDEVICELIST_SUCCESS,
    ACTION_GETDEVICEDETAIL_SUCCESS
} from '../../actions/scanner/device'

export interface deviceState {
    deviceList: any
    deviceDetail: any
}

const defaultState: deviceState = {
    deviceList: {},
    deviceDetail: {}
}

function handleActionGetDeviceListSuccess(state: deviceState, action): deviceState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        deviceList: action.payload.data
    }
}

function handleActionGetDeviceDetailSuccess(state: deviceState, action): deviceState {
    console.log(`ACTION: ${action.type}`);
    return {
        ...state,
        deviceDetail: action.payload.data
    }
}

export const deviceReducer: Reducer<deviceState, any> = handleActions(
    {
        [ACTION_GETDEVICELIST_SUCCESS]: handleActionGetDeviceListSuccess,
        [ACTION_GETDEVICEDETAIL_SUCCESS]: handleActionGetDeviceDetailSuccess
    },
    defaultState
)